import { RestUrl } from "../common/cyan.types";

export class BuilderPopupUrl {
  public static getPopups: RestUrl = ["GET", "/popups"];
}
